import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  makeStyles,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { FC } from "react";

export const useStyles = makeStyles(
  theme => ({
    btnCloseIcon: {
      marginLeft: "370px"
    },
    btnRemit: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main
    },
    buttonActionCenter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginTop: 20
    },
    centerContent: {
      fontWeight: 500,
      padding: 10,
      textAlign: "center"
    },
    displayFlexMarginRight20: {
      marginRight: "20px"
    },
    divFlexCentered: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20
    },
    templateDialogTitle: {
      fontSize: 20,
      fontWeight: 700,
      marginLeft: 2
    },
    textWhite: {
      color: "#FFF"
    }
  }),
  { name: "RemittanceRunnerMarkAsCollectedModalStyles" }
);

export interface RemittanceRunnerMarkAsCollectedModalProps {
  displayDialog: boolean;
  onClose: () => void;
  handleSave: (_forCollection: any) => void;
}

const RemittanceRunnerMarkAsCollectedModal: FC<RemittanceRunnerMarkAsCollectedModalProps> = props => {
  const { displayDialog, onClose, handleSave } = props;
  const classes = useStyles({});

  return (
    <Dialog
      open={displayDialog}
      maxWidth="xs"
      aria-labelledby="mark-as-collected-dialog-title"
      aria-describedby="mark-as-collected-dialog"
    >
      <DialogContent>
        <CloseIcon className={classes.btnCloseIcon} onClick={onClose} />
        <DialogContentText id="mark-as-collected-dialog">
          <div className={classes.divFlexCentered}>
            <Typography className={classes.templateDialogTitle} variant="h5">
              Payment Collection
            </Typography>
          </div>

          <div className={classes.centerContent}>
            {
              "Are you sure you collected the correct total amount for the selected mother orders?"
            }
          </div>

          <div className={classes.buttonActionCenter}>
            <Button
              color="primary"
              variant="outlined"
              className={classes.displayFlexMarginRight20}
              onClick={onClose}
            >
              NO
            </Button>
            <Button
              color="inherit"
              variant="contained"
              className={classes.btnRemit}
              onClick={handleSave}
            >
              <Typography className={classes.textWhite}>YES</Typography>
            </Button>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default RemittanceRunnerMarkAsCollectedModal;
